import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// GET /api/v1/cycles/
// → [{ id, student: {id, full_name, email}, cycle_number, status, last_class, months_completed }]
// Returns INTERRUPTED cycles for all students in the owner's company.
function usePortfolio() {
  return useQuery({
    queryKey: ["portfolio", "cycles"],
    queryFn: () =>
      apiClient.get("/api/v1/cycles/").then((r) => r.data),
  });
}

export { usePortfolio };
